import axios from "axios";
import { getToken } from "../../auth/authService";

const api = axios.create({
 baseURL: process.env.REACT_APP_BASE_URL,
 headers: {
 Authorization: `Bearer ${getToken()}`,
 },
});

/**
 * ===============================
 * ADMIN SESSION BOOKINGS
 * ===============================
 */

/**
 * Get all session bookings
 * Optional filter by canceled=true/false (future ready)
 */
export const fetchAllSessionBookings = (canceled = null) => {
 const params = {};
 if (canceled !== null) params.canceled = canceled;

 return api.get("/admin/session-bookings", { params });
};

/**
 * Update Zoom link for a booking
 */
export const updateSessionZoomLink = (bookingId, zoomLink) =>
 api.put(`/admin/session-bookings/${bookingId}/zoom-link/update`, null, {
 params: { zoomLink },
 });

/**
 * Cancel a booking by admin
 */
export const cancelSessionBooking = (bookingId) =>
 api.put(`/admin/session-bookings/${bookingId}/cancel`);

/**
 * Generate Zoom link for a booking (backend generates it)
 * Returns: { status, zoomLink, message }
 */
export const generateSessionZoomLink = async (bookingId) => {
 try {
 const response = await api.post(
 `/admin/session-bookings/${bookingId}/generate-zoom`
 );

 // Backend now returns structured response
 // e.g., { zoomLink: "...", message: "Zoom link created" }
 return {
 status: response.status, // 201, 200, etc.
 zoomLink: response.data?.zoomLink || null,
 message: response.data?.message || "Unknown status",
 };
 } catch (err) {

 // Capture backend response if available
 const status = err.response?.status || 500;
 const message =
 err.response?.data?.message ||
 err.response?.data ||
 err.message ||
 "Unknown error";

 return { status, zoomLink: null, message };
 }
};
